module.exports = __webpack_public_path__ + "static/img/certificate.725b57e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ServiceCase/certificate.png
// module id = RFq9
// module chunks = 1